import Keycloak from "keycloak-js";

export const verifyToken = async (keycloak: Keycloak) => {
    if (!keycloak?.authenticated || !keycloak.token) {
        console.warn("Claude API call, not authenticated with IRIS.");
        // Fire-and-forget: logout is a best-effort redirect. We return undefined
        // immediately so callers can abort their request without waiting.
        keycloak
            ?.logout({ redirectUri: import.meta.env.VITE_APP_URL })
            .then(() => {
                console.log("Iris: Logout success");
            })
            .catch(() => {
                console.log("Iris: Logout failed");
            });

        return keycloak.token;
    }

    console.log("Claude API call, authenticated with IRIS.");
    if (keycloak.isTokenExpired(50)) {
        console.log("Claude API call, access token is expired.");
        await keycloak.updateToken(50);
    }

    return keycloak.token;
};
